import script from './picker.vue_vue&type=script&lang.mjs';
export { default } from './picker.vue_vue&type=script&lang.mjs';
import { render } from './picker.vue_vue&type=template&id=1d54be91&lang.mjs';

script.render = render;
script.__file = "packages/components/time-picker/src/common/picker.vue";
//# sourceMappingURL=picker.mjs.map
